
export function jsonTryParse(value: any) {
	const response = {
		value,
		isValid: true,
	};
	value = typeof value !== 'string'
        ? JSON.stringify(value)
        : value;

	try {
		value = JSON.parse(value);
	}
	catch (e) {
		response.isValid = false;
	}
	if (response.isValid) {
		if (typeof value === 'object' && value !== null) {
			response.value = value;
			response.isValid = true;
		}
		else {
			response.isValid = false;
		}
	}
	return response;
}

export function stringifySafe(obj: any, circularPrefix: string = '__cache_index_'): string {
	let cache: Map<any, number> = new Map();
	let counter = 0;
	let output = JSON.stringify(obj, (key, value) => {
		if (typeof value === 'object' && value !== null) {
			// Duplicate reference found, return the cache index key
			if (cache.has(value)) return `${circularPrefix}${cache.get(value)}`;

			// Store value in our cache
			cache.set(value, counter++);
		}
		return value;
	});
	cache = new Map();
	return output;
};